import { render, staticRenderFns } from "./upload-document.vue?vue&type=template&id=055822bd&scoped=true"
import script from "./upload-document.vue?vue&type=script&lang=ts"
export * from "./upload-document.vue?vue&type=script&lang=ts"
import style0 from "./upload-document.vue?vue&type=style&index=0&id=055822bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055822bd",
  null
  
)

export default component.exports